/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './insurance-policy.reducer';

export const InsurancePolicyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const insurancePolicyEntity = useAppSelector(state => state.insurancePolicy.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="insurancePolicyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.insurancePolicy.detail.title">InsurancePolicy</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.id">Id</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.startDate}</dd>
          <dt>
            <span id="expiryDate">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.expiryDate">Expiry Date</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.expiryDate}</dd>
          <dt>
            <span id="policyNumber">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.policyNumber">Policy Number</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.policyNumber}</dd>
          <dt>
            <span id="allowedMoney">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.allowedMoney">Allowed Money</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.allowedMoney}</dd>
          <dt>
            <span id="usedMoney">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.usedMoney">Used Money</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.usedMoney}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.status">Status</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.status}</dd>
          <dt>
            <span id="insuranceType">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.insuranceType">Insurance Type</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.insuranceType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.active">Active</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {insurancePolicyEntity.microSec ? (
              <TextFormat value={insurancePolicyEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {insurancePolicyEntity.timestampEntry ? (
              <TextFormat value={insurancePolicyEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {insurancePolicyEntity.lastUpdated ? (
              <TextFormat value={insurancePolicyEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.cursor}</dd>
          <dt>
            <span id="employerName">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.employerName">Employer Name</Translate>
            </span>
          </dt>
          <dd>{insurancePolicyEntity.employerName}</dd>
          <dt>
            <span id="lastUpdateReason">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.lastUpdateReason">Last Update Reason</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdateReason">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.help.lastUpdateReason" />
            </UncontrolledTooltip>
          </dt>
          <dd>{insurancePolicyEntity.lastUpdateReason}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.insurancePolicy.provider">Provider</Translate>
          </dt>
          <dd>{insurancePolicyEntity.provider ? insurancePolicyEntity.provider.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.insurancePolicy.patient">Patient</Translate>
          </dt>
          <dd>{insurancePolicyEntity.patient ? insurancePolicyEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.insurancePolicy.subscriber">Subscriber</Translate>
          </dt>
          <dd>{insurancePolicyEntity.subscriber ? insurancePolicyEntity.subscriber.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/insurance-policy" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/insurance-policy/${insurancePolicyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InsurancePolicyDetail;
